import PropTypes from "prop-types";

import Rating from "../../Rating";

function ProductReview({ reviewData }) {
  const { customer_name, post_date, description, rating } = reviewData;

  return (
    <article>
      <Rating ratingNumber={rating} />
      <div className="mb-[1rem] mt-[1.125rem] max-w-[46.25rem] break-all text-grayD4">
        {description}
      </div>
      <small className="block text-[0.875rem] text-grayD4">
        By<span className="text-primary">&nbsp; {customer_name} &nbsp;</span>
        {post_date}
      </small>
    </article>
  );
}

ProductReview.propTypes = {
  reviewData: PropTypes.shape({
    customer_name: PropTypes.string,
    post_date: PropTypes.string,
    description: PropTypes.string,
    rating: PropTypes.number,
  }),
};

export default ProductReview;
